import http from "@/services/http";

// Dados do Tomador
const getQuiverPointSaleOptions = () => http.get(`quiver/point-sale-options/`)
const getQuiverBusinessLineOptions = () => http.get(`quiver/business-line-options/`)
const getQuiverBusinessOriginOptions = () => http.get(`quiver/business-origin-options/`)
const getQuiverChannelOptions = () => http.get(`quiver/channel-options/`)
const getQuiverHoldingOptions = () => http.get(`quiver/holding-options/`)
const getQuiverRegionalOptions = () => http.get(`quiver/regional-options/`)
const getQuiverCoBrokersOptions = () => http.get(`quiver/co-brokers-options/`)
const getQuiverIndicatorUsersOptions = () => http.get(`quiver/indicator-users/`)
const storeQuiverIndicatorUser = (params) => http.post(`quiver/indicator-users`, params)
const updateQuiverIndicatorUser = (quiverIndicatorUserId, params) => http.put(`quiver/indicator-users/${quiverIndicatorUserId}`, params)
const destroyQuiverIndicatorUser = (quiverIndicatorUserId) => http.delete(`quiver/indicator-users/${quiverIndicatorUserId}`)

export default {
  getQuiverPointSaleOptions,
  getQuiverBusinessLineOptions,
  getQuiverBusinessOriginOptions,
  getQuiverChannelOptions,
  getQuiverHoldingOptions,
  getQuiverRegionalOptions,
  getQuiverCoBrokersOptions,
  getQuiverIndicatorUsersOptions,
  storeQuiverIndicatorUser,
  updateQuiverIndicatorUser,
  destroyQuiverIndicatorUser
}
